import React, { useEffect } from "react";
import injectSheet from "react-jss";
import { scroller } from "react-scroll/modules";
import useReactRouter from "use-react-router";
import { useInitialRender } from "providers/InitialRenderProvider/InitialRenderProvider";

const styles = ({ theme }) => {
  return {
    root: {
      padding: `${theme.padding.sm} ${theme.padding.md}`
    }
  };
};
const ItemListItemBody = ({ classes, children, expanded, id }) => {
  const { location } = useReactRouter();
  const isInitialRender = useInitialRender();
  useEffect(() => {
    if (expanded && !isInitialRender) {
      if (location.state && location.state.scrollIntoView) {
        scroller.scrollTo(id, {
          isDynamic: true,
          smooth: true,
          delay: 100,
          duration: 300
        });
      }
      const element = document.querySelector(`div[name='${id}']`);
      element.scrollIntoView();
    }
  }, [id, expanded, location.state, isInitialRender]);
  return (
    <>
      <div style={{ display: expanded ? null : "none" }}>
        <div
          aria-expanded={expanded ? "true" : "false"}
          className={classes.root}
          role="tabpanel"
        >
          {children}
        </div>
      </div>
    </>
  );
};

ItemListItemBody.propTypes = {};

export default injectSheet(styles)(ItemListItemBody);
